import { ICurrency } from 'meta/currency'
import { SliceSelector } from 'store/types'

const getCurrency: SliceSelector<ICurrency> = () => (state) => state.currency

export const CurrencySelectors = {
  getCurrency,
}
